import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';

// componentes
import TextField from '../../../../../components/TextField';

//helpers
import mascaras from '../../../../../helpers/mascaras';
import { showMessage } from '../../../../../helpers/message';

// API
import cep_api from '../../../../../api/cep_api';
import requerente_api from '../../../../../api/requerente_api';

//Context
import { useAuth } from '../../../../../context/auth';

function DadosRequerente({ requerente, setRequerente, errors }) {
  const { setLoading } = useAuth();

  const onBlurCep = (e) => {
    const { name, value } = e.target;
    const _cep = mascaras.cepMask(value, true);

    if (_cep.length === 8) {
      setLoading(true);
      cep_api.get(_cep).then(response => {
        setRequerente({
          ...requerente,
          uf: response.data.uf,
          cidade: response.data.localidade,
          bairro: response.data.bairro,
          logradouro: response.data.logradouro,
          complemento: response.data.complemento
        })
      })
        .catch(e => showMessage("Error ", e.message, "error", null))
        .finally(() => setLoading(false))
    }
  }

  useEffect(() => {
    setLoading(true);
    requerente_api.getDadosRequerente().then(response => {
      setRequerente(response.data);
    }).catch(ex => showMessage("Erro", ex.message, "error", null))
      .finally(f => setLoading(false));
  }, []);

  return <>
    <div className="formContainer">
      <Row className='mx-4'>
        <Col md="12" lg="12">
          <h6 style={{ color: "#666" }}>Preencha os dados de requerente</h6>
        </Col>
        <Col md="12" lg="4">
          <TextField
            label={"* Solicitante"}
            name={"nome"}
            type={"text"}
            value={requerente.nome}
            invalid={!!errors.nome}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            label={"* Numero do processo"}
            name={"documentoPessoal"}
            type={"text"}
            value={requerente.documentoPessoal}
            invalid={!!errors.documentoPessoal}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            label={"* E-mail"}
            name={"email"}
            type={"text"}
            value={requerente.email}
            invalid={!!errors.email}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            label={"*Telefone"}
            mask={mascaras.telefoneMask}
            maxLength={13}
            name={"telefone"}
            type={"text"}
            value={requerente.telefone}
            invalid={!!errors.telefone}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
        <Col md="12" lg="3">
          <TextField
            label={<><span>*</span>CEP</>}
            mask={mascaras.cepMask}
            maxLength={9}
            onBlur={onBlurCep}
            name={"cep"}
            type={"text"}
            value={requerente.cep}
            invalid={!!errors.cep}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
        <Col md="12" lg="2">
          <TextField
            label={<><span>*</span>UF</>}
            name={"uf"}
            type={"text"} value={requerente.uf}
            invalid={!!errors.uf}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
        <Col md="12" lg="3">
          <TextField
            label={<><span>*</span>Cidade</>}
            name={"cidade"}
            type={"text"} value={requerente.cidade}
            invalid={!!errors.cidade}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>

        <Col md="12" lg="4">
          <TextField
            label={<><span>*</span>Bairro</>}
            name={"bairro"}
            type={"text"} value={requerente.bairro}
            invalid={!!errors.bairro}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
        <Col md="12" lg="6">
          <TextField
            label={<><span>*</span>Logradoudo</>}
            name={"logradouro"}
            type={"text"} value={requerente.logradouro}
            invalid={!!errors.logradouro}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
        <Col md="12" lg="2">
          <TextField
            label={<><span>*</span>Numero</>}
            name={"numero"}
            type={"number"} value={requerente.numero}
            invalid={!!errors.numero}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>

        <Col md="12">
          <TextField
            label={"Complemento"}
            name={"complemento"}
            type={"text"} value={requerente.complemento}
            onChange={e => setRequerente({ ...requerente, [e.target.name]: e.target.value })}
          />
        </Col>
      </Row>
    </div>
  </>
}

export default DadosRequerente;